/**
 * FR8 fix #1 — single canonical globalThis pin keys for the NATS
 * connection singleton.
 *
 * Two slots, two keys, ONE source-of-truth file. Drift between modules
 * (cold-connect, HMR-cleanup, RN drain, app-state listener) writes to
 * different globals and silently breaks the post-drain singleton-reset
 * contract documented at spec §2967.
 *
 * Every file that touches these slots imports the constant from here —
 * never inlines the string literal. A grep audit verifies the
 * single-declaration invariant.
 *
 * @see packages/backend-sdk-v2/docs/postmortems/2026-XX-singleton-drift.md
 */

/** Pin for the in-flight connect promise (used by cold-connect singleton). */
export const CONNECTION_PROMISE_GLOBAL_KEY = '__morfi_connectionPromise' as const;

/** Servers the pinned connect promise targets; a different server retires the pin. */
export const CONNECTION_SERVERS_GLOBAL_KEY = '__morfi_connectionServers' as const;

/** Pin for the resolved NatsConnection (drain target after wsconnect resolves). */
export const NATS_CLIENT_GLOBAL_KEY = '__morfi_natsClient' as const;

/** Devtool connection ledger — every client this tab opened (`connection-ledger.ts`). */
export const CONNECTION_LEDGER_GLOBAL_KEY = '__morfi_connectionLedger' as const;
